module.exports = __webpack_public_path__ + "img/card1.309372b2.jpg";